import { useMemo } from "react";
import { useLanguageContext } from "@/context/LanguageContext";
import iconGuideData from "@/static/constants/iconGuide";
import {
  IconGuideItemLabels,
  IconGuideItemWithLabels,
} from "@/types/IconGuide.types";

const useIconGuide = () => {
  const { languageText } = useLanguageContext();

  const guideLabels = useMemo(
    () => languageText?.LABELS?.GUIDE ?? {},
    [languageText]
  );

  const guideItems = useMemo(
    () =>
      (guideLabels.ITEMS as Record<string, IconGuideItemLabels> | undefined) ??
      {},
    [guideLabels]
  );

  const items: IconGuideItemWithLabels[] = useMemo(
    () =>
      iconGuideData.map((item) => {
        const itemLabels = guideItems[item.id];

        return {
          ...item,
          name: itemLabels?.NAME ?? "",
          description: itemLabels?.DESCRIPTION ?? "",
        };
      }),
    [guideItems]
  );

  const columnLabels = guideLabels.COLUMNS ?? {};

  return {
    triggerLabel: guideLabels.TRIGGER_LABEL ?? "Guide",
    modalTitle: guideLabels.MODAL_TITLE ?? "Guide",
    emptyMessage: guideLabels.EMPTY_MESSAGE ?? "",
    columns: {
      symbol: columnLabels.SYMBOL ?? "",
      name: columnLabels.NAME ?? "",
      description: columnLabels.DESCRIPTION ?? "",
    },
    items,
  };
};

export default useIconGuide;
